/* Bye Olor · carrusel de videos (sections/bo-videos.liquid)
   - Solo se reproduce el video protagonista (el más centrado). Los demás quedan en pausa.
   - Arranca silenciado (reglas de autoplay de los navegadores). El sonido se activa con un toque.
   - La preferencia de sonido se mantiene durante la sesión; si el navegador bloquea el audio
     al cambiar de video, vuelve a silenciar y muestra otra vez "Activar sonido".
   - Pausa si la sección sale de pantalla o si se cambia de pestaña.
   - Respeta prefers-reduced-motion (no reproduce solo).
   - Los videos no se descargan hasta que la sección se acerca a la pantalla. */
(function () {
  if (window.__bovInit) return;
  window.__bovInit = true;

  var SS_KEY = 'bov-sound';
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  function isDesk() { return !!(mqDesk && mqDesk.matches); }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function getSound() { try { return sessionStorage.getItem(SS_KEY) === '1'; } catch (e) { return false; } }
  function setSoundPref(v) { try { sessionStorage.setItem(SS_KEY, v ? '1' : '0'); } catch (e) {} }

  function Carousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-bov-track]');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-bov-slide]'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-bov-dot]'));
    this.prev = root.querySelector('[data-bov-prev]');
    this.next = root.querySelector('[data-bov-next]');
    this.active = -1;
    this.inView = false;
    this.near = false;
    this.userPaused = false;
    this.sound = getSound();
    this.raf = 0;
    this.target = null;
    this.pin = null;
    if (!this.track || !this.slides.length) return;
    this.bind();
    this.setSoundUI();
    this.update(true);
  }

  Carousel.prototype.video = function (i) {
    var s = this.slides[i];
    return s ? s.querySelector('[data-bov-video]') : null;
  };

  Carousel.prototype.load = function (i) {
    var v = this.video(i);
    if (v && !v.getAttribute('src') && v.dataset.src) {
      v.setAttribute('src', v.dataset.src);
      v.preload = i === this.active ? 'auto' : 'metadata';
    }
  };

  Carousel.prototype.bind = function () {
    var self = this;

    this.track.addEventListener('scroll', function () {
      if (self.raf) return;
      self.raf = requestAnimationFrame(function () { self.raf = 0; self.update(false); });
    }, { passive: true });
    window.addEventListener('resize', function () { self.update(false); }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          self.inView = e.isIntersecting && e.intersectionRatio >= 0.35;
          self.covering = e.isIntersecting && e.intersectionRatio >= 0.2;
        });
        setCover();
        self.sync();
        self.maybeNudge();
      }, { threshold: [0, 0.2, 0.35, 0.6] }).observe(this.root);

      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !self.near) {
            self.near = true;
            self.preloadAround();
            self.sync();
          }
        });
      }, { rootMargin: '400px 0px' }).observe(this.root);
    } else {
      this.inView = this.near = true;
    }

    document.addEventListener('visibilitychange', function () { self.sync(); });

    this.slides.forEach(function (slide, i) {
      var v = slide.querySelector('[data-bov-video]');
      var tap = slide.querySelector('[data-bov-tap]');
      var play = slide.querySelector('[data-bov-play]');
      var mute = slide.querySelector('[data-bov-mute]');
      var snd = slide.querySelector('[data-bov-sound]');
      var seek = slide.querySelector('[data-bov-seek]');

      slide.addEventListener('click', function (e) {
        if (i !== self.active) { e.preventDefault(); e.stopPropagation(); self.goTo(i); }
      }, true);

      if (!v) return;
      if (tap) tap.addEventListener('click', function () {
        if (!self.sound) { self.enableSound(); return; }
        self.togglePlay();
      });
      if (play) play.addEventListener('click', function () { self.togglePlay(); });
      if (mute) mute.addEventListener('click', function () { self.sound ? self.disableSound() : self.enableSound(); });
      if (snd) snd.addEventListener('click', function () { self.enableSound(); });

      v.addEventListener('playing', function () {
        slide.classList.add('is-started'); slide.classList.remove('is-paused');
        if (play) play.setAttribute('aria-label', 'Pausar');
        if (seek) self.tick(v, seek);
      });
      v.addEventListener('pause', function () {
        slide.classList.add('is-paused');
        if (play) play.setAttribute('aria-label', 'Reproducir');
      });
      if (seek) {
        var paint = function () { self.paint(v, seek, true); };
        v.addEventListener('timeupdate', paint);
        v.addEventListener('seeked', paint);
        v.addEventListener('loadedmetadata', paint);
        self.bindSeek(seek, v, i);
      }
    });

    this.dots.forEach(function (d) {
      d.addEventListener('click', function () { self.goTo(parseInt(d.dataset.bovDot, 10)); });
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.goTo(Math.max(self.active - 1, 0)); });
    if (this.next) this.next.addEventListener('click', function () { self.goTo(Math.min(self.active + 1, self.slides.length - 1)); });

    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(Math.min(self.active + 1, self.slides.length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(Math.max(self.active - 1, 0)); }
    });
  };

  /* Barra de progreso interactiva.
     - paint: dibuja el avance (variable CSS --bov-p). Mientras se arrastra o el video está buscando
       la posición, no se pisa lo que eligió el usuario.
     - tick: mientras el video se reproduce, actualiza la barra en cada cuadro (más fluido que timeupdate).
     - bindSeek: tocar/clic en cualquier punto salta ahí; arrastrar adelanta o retrocede (mouse y touch,
       con pointer events). No pausa ni reanuda el video: respeta play/pausa, sonido y protagonista.
       La zona usa touch-action: pan-y, así el arrastre horizontal no mueve el carrusel y el scroll
       vertical de la página sigue funcionando. Teclado: flechas ±5 s, Inicio/Fin. */
  function fmt(t) { t = Math.max(0, Math.floor(t || 0)); return Math.floor(t / 60) + ':' + ('0' + (t % 60)).slice(-2); }

  Carousel.prototype.paint = function (v, seek, aria) {
    if (!v.duration || seek.__drag || v.seeking) return;
    var p = Math.min(1, Math.max(0, v.currentTime / v.duration));
    seek.style.setProperty('--bov-p', p);
    if (aria) {
      seek.setAttribute('aria-valuenow', Math.round(p * 100));
      seek.setAttribute('aria-valuetext', fmt(v.currentTime) + ' de ' + fmt(v.duration));
    }
  };

  Carousel.prototype.tick = function (v, seek) {
    var self = this;
    if (v.__bovTick) return;
    (function loop() {
      if (v.paused || v.ended) { v.__bovTick = 0; return; }
      self.paint(v, seek, false);
      v.__bovTick = requestAnimationFrame(loop);
    })();
  };

  Carousel.prototype.bindSeek = function (seek, v, i) {
    var self = this, rail = seek.querySelector('[data-bov-rail]') || seek, drag = false, pend = null, rs = 0;
    function ratio(x) {
      var r = rail.getBoundingClientRect();
      return r.width ? Math.min(1, Math.max(0, (x - r.left) / r.width)) : 0;
    }
    function apply(p) {
      seek.style.setProperty('--bov-p', p);
      if (!v.duration) { v.__bovPend = p; return; }
      pend = p;
      if (rs) return;
      rs = requestAnimationFrame(function () {
        rs = 0;
        if (pend == null || !v.duration) return;
        var t = Math.min(pend * v.duration, Math.max(0, v.duration - 0.05));
        pend = null;
        try { v.currentTime = t; } catch (e) {}
      });
    }
    function end(e) {
      if (!drag) return;
      drag = false; seek.__drag = false;
      seek.classList.remove('is-dragging');
      if (e && e.type === 'pointerup') apply(ratio(e.clientX));
    }
    v.addEventListener('loadedmetadata', function () {
      if (v.__bovPend != null) { var p = v.__bovPend; v.__bovPend = null; apply(p); }
    });
    seek.addEventListener('pointerdown', function (e) {
      if (i !== self.active || (e.button && e.button !== 0)) return;
      e.preventDefault(); e.stopPropagation();
      self.load(i);
      drag = true; seek.__drag = true;
      seek.classList.add('is-dragging');
      try { seek.setPointerCapture(e.pointerId); } catch (err) {}
      apply(ratio(e.clientX));
    });
    seek.addEventListener('pointermove', function (e) { if (drag) { e.preventDefault(); apply(ratio(e.clientX)); } });
    seek.addEventListener('pointerup', end);
    seek.addEventListener('pointercancel', end);
    seek.addEventListener('lostpointercapture', end);
    seek.addEventListener('click', function (e) { e.stopPropagation(); }); // no dispara play/pausa
    seek.addEventListener('keydown', function (e) {
      if (!v.duration) return;
      var t = null;
      if (e.key === 'ArrowRight') t = v.currentTime + 5;
      else if (e.key === 'ArrowLeft') t = v.currentTime - 5;
      else if (e.key === 'Home') t = 0;
      else if (e.key === 'End') t = v.duration - 0.05;
      if (t == null) return;
      e.preventDefault(); e.stopPropagation(); // no cambia de video
      apply(Math.min(1, Math.max(0, t / v.duration)));
    });
  };

  Carousel.prototype.goTo = function (i) {
    var s = this.slides[i];
    if (!s) return;
    var left = s.offsetLeft - (this.track.clientWidth - s.offsetWidth) / 2;
    if (isDesk()) {
      /* Desktop: se muestran 3 tarjetas a la vez y en los extremos (video 1 y 5) el carrusel no
         puede centrar la tarjeta, porque el scroll llega a su límite. Por eso el video elegido con
         flechas, puntos o clic queda como protagonista aunque no esté en el centro. */
      var max = this.track.scrollWidth - this.track.clientWidth;
      var dest = Math.max(0, Math.min(left, max));
      if (Math.abs(dest - this.track.scrollLeft) < 2) { this.target = null; this.pin = { i: i, left: this.track.scrollLeft }; this.setActive(i, false); return; }
      this.target = i;
      this.targetDest = dest;
      this.targetTs = Date.now();
    }
    this.track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  /* Protagonista = el slide más cercano al centro del carrusel */
  Carousel.prototype.update = function (force) {
    if (this.target != null) {
      // Desktop: navegación con flechas/puntos en curso; el protagonista se fija al llegar.
      if (Math.abs(this.track.scrollLeft - this.targetDest) < 2) {
        var t = this.target; this.target = null; this.pin = { i: t, left: this.track.scrollLeft }; this.setActive(t, force); return;
      }
      if (Date.now() - this.targetTs < 1000) return;
      this.target = null; // el usuario interrumpió la animación: se vuelve al cálculo normal
    }
    if (this.pin) {
      // Desktop: mientras no se mueva el carrusel, se mantiene el video elegido (aunque esté en un extremo).
      if (Math.abs(this.track.scrollLeft - this.pin.left) < 2) { this.setActive(this.pin.i, force); return; }
      this.pin = null;
    }
    var c = this.track.scrollLeft + this.track.clientWidth / 2, best = 0, bestD = Infinity;
    for (var i = 0; i < this.slides.length; i++) {
      var s = this.slides[i], d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c);
      if (d < bestD) { bestD = d; best = i; }
    }
    this.setActive(best, force);
  };

  Carousel.prototype.setActive = function (best, force) {
    if (best === this.active && !force) return;
    var prevActive = this.active;
    this.active = best;
    this.userPaused = false;
    for (var j = 0; j < this.slides.length; j++) {
      this.slides[j].classList.toggle('is-active', j === best);
      if (j !== best) {
        var v = this.video(j);
        if (v) { v.muted = true; if (!v.paused) v.pause(); }
      }
    }
    this.dots.forEach(function (d, k) { d.setAttribute('aria-current', k === best ? 'true' : 'false'); });
    if (this.prev) this.prev.disabled = best === 0;
    if (this.next) this.next.disabled = best === this.slides.length - 1;
    if (prevActive !== -1 && this.near) this.preloadAround();
    this.sync();
  };

  /* Mobile: pista de descubrimiento, una sola vez por visita a la página.
     ~1 s después de llegar a la sección (con el video 1 centrado) las tarjetas se corren 26 px a la
     izquierda y vuelven. Se hace con la propiedad CSS "translate" de las tarjetas (no mueve el scroll),
     así no interfiere con swipe, scroll-snap, protagonista ni reproducción.
     Se cancela al instante si el usuario toca o desliza el carrusel. Respeta prefers-reduced-motion. */
  Carousel.prototype.maybeNudge = function () {
    var self = this, tr = this.track;
    if (this.nudged || this.nudgeTimer || reduceMotion || !mqMobile || !mqMobile.matches) return;
    if (!this.inView || this.active !== 0 || this.slides.length < 2) return;
    var timers = [], evs = ['touchstart', 'pointerdown', 'wheel', 'scroll', 'keydown'];
    function reset() {
      timers.forEach(clearTimeout); timers = [];
      self.nudgeTimer = null;
      tr.classList.remove('bov-nudging');
      tr.style.removeProperty('--bov-nudge');
      evs.forEach(function (ev) { tr.removeEventListener(ev, onUser); });
    }
    function onUser() { self.nudged = true; reset(); }
    evs.forEach(function (ev) { tr.addEventListener(ev, onUser, { passive: true }); });
    this.nudgeTimer = setTimeout(function () {
      if (!self.inView || self.active !== 0 || document.hidden) { reset(); return; } // se reintenta en la próxima visita a la sección
      self.nudged = true;
      tr.classList.add('bov-nudging');
      tr.style.setProperty('--bov-nudge', '-26px');
      timers.push(setTimeout(function () {
        tr.style.setProperty('--bov-nudge', '0px');
        timers.push(setTimeout(reset, 550));
      }, 600));
    }, 1000);
    timers.push(this.nudgeTimer);
  };

  Carousel.prototype.preloadAround = function () {
    this.load(this.active);
    this.load(this.active + 1);
  };

  /* Decide si el protagonista debe reproducirse */
  Carousel.prototype.sync = function () {
    var v = this.video(this.active);
    var slide = this.slides[this.active];
    if (!v) return;
    var shouldPlay = this.inView && this.near && !document.hidden && !this.userPaused && !reduceMotion;
    if (!shouldPlay) {
      if (!v.paused) v.pause();
      slide.classList.add('is-paused');
      return;
    }
    this.load(this.active);
    this.play(v, slide);
  };

  Carousel.prototype.play = function (v, slide) {
    var self = this;
    v.muted = !this.sound;
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      if (!v.muted) {
        // El navegador no permitió audio sin un toque: se silencia y se vuelve a mostrar el botón.
        self.sound = false;
        self.setSoundUI();
        v.muted = true;
        v.play().catch(function () { slide.classList.add('is-paused'); });
      } else {
        slide.classList.add('is-paused');
      }
    });
  };

  Carousel.prototype.togglePlay = function () {
    var v = this.video(this.active), slide = this.slides[this.active];
    if (!v) return;
    if (v.paused) {
      this.userPaused = false;
      this.load(this.active);
      this.play(v, slide);
    } else {
      this.userPaused = true;
      v.pause();
    }
  };

  /* Llamado siempre desde un toque del usuario: habilita el audio en todos los navegadores */
  Carousel.prototype.enableSound = function () {
    this.sound = true;
    setSoundPref(true);
    this.setSoundUI();
    this.userPaused = false;
    var v = this.video(this.active), slide = this.slides[this.active];
    if (!v) return;
    this.load(this.active);
    v.muted = false;
    this.play(v, slide);
  };

  Carousel.prototype.disableSound = function () {
    this.sound = false;
    setSoundPref(false);
    this.setSoundUI();
    var v = this.video(this.active);
    if (v) v.muted = true;
  };

  Carousel.prototype.setSoundUI = function () {
    var self = this;
    this.root.classList.toggle('is-sound', this.sound);
    this.root.querySelectorAll('[data-bov-mute]').forEach(function (b) {
      b.setAttribute('aria-label', self.sound ? 'Silenciar' : 'Activar sonido');
    });
  };

  /* Elementos flotantes que no deben tapar los videos en mobile (ver bo-videos.css).
     El popup de compras se oculta por su id (#wisherProofPop). Para WhatsApp se busca el botón
     flotante de la app (enlace a wa.me / whatsapp) y se marca su contenedor fijo con .bov-float. */
  var mqMobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var FLOAT_SEL = 'a[href*="wa.me"],a[href*="whatsapp.com"],a[href*="api.whatsapp"],[id*="whatsapp" i],[class*="whatsapp" i]';
  function markFloats() {
    var found = document.querySelectorAll(FLOAT_SEL);
    for (var i = 0; i < found.length; i++) {
      var el = found[i], fixed = null, n = el;
      if (el.closest('.bov')) continue;
      while (n && n !== document.body && n !== document.documentElement) {
        if (getComputedStyle(n).position === 'fixed') fixed = n;
        n = n.parentElement;
      }
      if (fixed) fixed.classList.add('bov-float');
    }
  }
  function setCover() {
    var any = false;
    document.querySelectorAll('[data-bov]').forEach(function (r) { if (r.__bov && r.__bov.covering) any = true; });
    var on = any && (!mqMobile || mqMobile.matches);
    if (on) markFloats();
    document.documentElement.classList.toggle('bov-cover', on);
  }
  if (mqMobile && mqMobile.addEventListener) mqMobile.addEventListener('change', setCover);

  function init(scope) {
    (scope || document).querySelectorAll('[data-bov]').forEach(function (root) {
      if (!root.__bov) root.__bov = new Carousel(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Editor de temas de Shopify: re-inicializar al recargar la sección
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
